import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/payment'
    },
    {
        path: '/payment',
        component: () => import("@/views/home/Payment"),
        meta: {title: "聚合支付"}
    },
    {
        path: '/dcPayment',
        component: () => import("@/views/home/DcPayment"),
        meta: {title: "数币支付"}
    },
    {
        path: '/orderDetail',
        component: () => import("@/views/home/OrderDetail"),
        meta: {title: "订单详情"}
    },
    {
        path: '*',
        redirect: '/index'
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {//如果设置标题，拦截后设置标题
        document.title = to.meta.title
    }
    next()
})
export default router
